import axios from 'axios';
import { GET_MY_SITE } from '../../constants';

/**
 * Function to get mySite's detail
 */
export const getMySite = (facilityId, userId, clientId, shared) =>
  axios.get(`${GET_MY_SITE}?client=${clientId}&user_id=${userId}&facilitysk=${facilityId}&shared=${shared}`);
